(function ($, Drupal) {

  Drupal.behaviors.showOptions = {
    attach: function (context, settings) {
      'use strict';

      const links = $('.top-button a');
      if (links.length) {
        const cards = $('.grid');

        // Hide the grid.
        cards.hide();

        // Display on click with an href of '#' .
        links.once('showOptions').on('click', {cards: cards}, function(e) {

          if (this.href == this.baseURI + '#') {
            e.preventDefault();

            // Display the cards.
            e.data.cards.show();
            return false;
          }
          return true;
        });
      }
    }
  };

})(jQuery, Drupal);
